// Sort 버튼 오류 해결
  // Sort 버튼 열기/닫기
  document.addEventListener(
    'click',
    function (event) {
      const sortToggle = event.target.closest('[data-sort-toggle]');

      if (sortToggle) {
        const container =
          sortToggle.closest('collection-filters') ||
          sortToggle.closest('[data-section-id]');

        const sortOptions = container?.querySelector(
          '[data-collection-sort-options]'
        );

        if (!sortOptions) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const isOpen = sortOptions.classList.toggle(
          'collection__sort__option-wrapper--visible'
        );

        sortToggle.setAttribute('aria-expanded', String(isOpen));

        return;
      }

      // Sort 영역 바깥을 클릭하면 닫기
      document
        .querySelectorAll(
          '[data-collection-sort-options].collection__sort__option-wrapper--visible'
        )
        .forEach((sortOptions) => {
          if (sortOptions.contains(event.target)) return;

          sortOptions.classList.remove(
            'collection__sort__option-wrapper--visible'
          );

          const container =
            sortOptions.closest('collection-filters') ||
            sortOptions.closest('[data-section-id]');

          container
            ?.querySelector('[data-sort-toggle]')
            ?.setAttribute('aria-expanded', 'false');
        });
    },
    true
  );


  // AJAX 교체 후 새 Sort 옵션 변경 처리
  document.addEventListener(
    'change',
    function (event) {
      const sortInput = event.target.closest('[data-input-sort]');

      if (!sortInput) return;

      const container =
        sortInput.closest('collection-filters') ||
        sortInput.closest('[data-section-id]');

      if (!container) return;

      // Search 페이지는 기존 테마 이벤트 사용
      if (container.closest('[data-search-performed]')) return;

      event.stopImmediatePropagation();

      const selectedValue = sortInput.value;

      // 모바일/데스크톱용 Sort input 값 동기화
      container
        .querySelectorAll('[data-input-sort]')
        .forEach((input) => {
          input.checked = input.value === selectedValue;
        });

      const filtersForm = container.querySelector(
        '[data-collection-filters-form]'
      );

      if (!filtersForm) return;

      // 기존 테마의 AJAX 필터 갱신 실행
      filtersForm.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      // 선택 후 리스트 닫기
      const sortOptions = container.querySelector(
        '[data-collection-sort-options]'
      );

      sortOptions?.classList.remove(
        'collection__sort__option-wrapper--visible'
      );

      container
        .querySelector('[data-sort-toggle]')
        ?.setAttribute('aria-expanded', 'false');
    },
    true
  );


// 모바일 filter & sort 오류 해결
  // 모바일 Filter & Sort 버튼
  document.addEventListener(
    'click',
    function (event) {
      const filterToggle = event.target.closest('[data-toggle-filters]');

      if (!filterToggle) return;

      const container =
        filterToggle.closest('collection-filters') ||
        filterToggle.closest('[data-section-id]');

      const filters = container?.querySelector(
        '[data-collection-filters]'
      );

      if (!filters) return;

      // Search 페이지는 기존 테마 이벤트 사용
      if (container.closest('[data-search-performed]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const isOpen = filters.classList.contains(
        'collection__filters--visible'
      );

      if (isOpen) {
        filters.classList.remove('collection__filters--visible');

        document.dispatchEvent(
          new CustomEvent('theme:scroll:unlock', {
            bubbles: true,
            detail: 300
          })
        );
      } else {
        filters.classList.add('collection__filters--visible');

        document.dispatchEvent(
          new CustomEvent('theme:scroll:lock', {
            bubbles: true,
            detail: filters.querySelector(
              '[data-collection-filters-list]'
            )
          })
        );
      }

      filterToggle.setAttribute(
        'aria-expanded',
        String(!isOpen)
      );
    },
    true
  );


// Footer menu
  document.addEventListener('DOMContentLoaded', () => {
    const menuButtons = document.querySelectorAll('.neo-footer__menu-button');

    menuButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (window.innerWidth > 768) return;

        const childMenu = button.nextElementSibling;

        if (!childMenu?.classList.contains('neo-footer__menu--child')) return;

        const isOpen = button.classList.toggle('is-open');

        childMenu.style.height = isOpen
          ? `${childMenu.scrollHeight}px`
          : '0px';
      });
    });
  });